import styles from './styles.module.scss';

type NotFoundProps = {
  message?: string;
};

const NotFound: React.FC<NotFoundProps> = (props) => {
  const { message = 'Ничего не найдено' } = props;

  return <p className={styles.message}>{message}</p>;
};

export default NotFound;
